import * as React from "react";
import { useLogin, useNotify } from "react-admin";
import { Form, Field } from "react-final-form";
import { Button } from "@material-ui/core";
import axios from "axios";
import labelsTranslation from "../../translations/tranlation";

const IranMobileRegex = /^((0)9\d{9})$/;

const required = (value: any, fieldLabel: any) =>
	value ? undefined : `لطفا ${fieldLabel} را وارد کنید`;
const regexMobile = (value: any) =>
	IranMobileRegex.test(value) ? undefined : "لطفا موبایل رو صحیح وارد نمایید";
const composeValidators =
	(...validators: any[]) =>
	(value: any) =>
		validators.reduce(
			(error, validator) => error || validator(value),
			undefined
		);

export const LoginWithOTP = ({ showOTP, setShowOTP }: any) => {
	const [mobile, setMobile] = React.useState("");
	const login = useLogin();
	const notify = useNotify();

	const sendOTP = (values: any) => {
		const { mobile } = values;
		setMobile(mobile);

		axios
			.post(`${process.env.REACT_APP_SERVER_ADDRESS_3015}/api/generate-otp`, {
				mobile,
			})
			.then((data) => {
				setShowOTP(true);
			})
			.catch((e) => {
				setShowOTP(false);
			});
	};
	const authOTP = (values: any) => {
		const { otp: OTP } = values;
		login({
			mobile,
			service: "doctor_sale",
			otpCode: OTP,
			registerIfNecessary: false,
			LOGIN_METHOD: "verify-otp",
		})
			.then((data) => {
				// console.log("third", data);
			})
			.catch((e: any) => {
				// console.log(e);
				notify(e[0]);
			});
	};
	return (
		<>
			{!showOTP ? (
				<Form
					onSubmit={sendOTP}
					render={({ handleSubmit, valid }) => (
						<form onSubmit={handleSubmit}>
							<label>
								<span>شماره موبایل</span>
								<Field
									style={{ border: "1px solid black" }}
									name="mobile"
									validate={composeValidators(
										(e: any) =>
											required(e, labelsTranslation.userCreate.mobile),
										regexMobile
									)}
								>
									{({ input, meta }) => (
										<div style={{ margin: " 0" }}>
											<input
												{...input}
												placeholder="09*********"
												type="textbox"
												style={{ margin: "2px 0" }}
											/>
											<p
												style={{
													color: "red",
													margin: "0",
													fontSize: ".75rem",
													textAlign: "right",
												}}
											>
												{meta.touched ? meta.error : ""}
											</p>
										</div>
									)}
								</Field>
							</label>
							<Button
								style={{ marginTop: "2rem" }}
								disabled={!valid}
								type="submit"
								variant="contained"
								color="primary"
							>
								ورود
							</Button>
						</form>
					)}
				/>
			) : (
				<Form
					onSubmit={authOTP}
					render={({ handleSubmit, valid }) => (
						<form onSubmit={handleSubmit}>
							<label>
								<span>کد ارسال شده</span>

								<Field name="otp" validate={(e) => required(e, "کد ارسال شده")}>
									{({ input, meta }) => (
										<div style={{ margin: " 0" }}>
											<input {...input} style={{ margin: "2px 0" }} />
											<p
												style={{
													color: "red",
													margin: "0",
													fontSize: ".75rem",
													textAlign: "right",
												}}
											>
												{meta.touched ? meta.error : ""}
											</p>
										</div>
									)}
								</Field>
							</label>
							<Button
								style={{ marginTop: "2rem" }}
								disabled={!valid}
								type="submit"
								variant="contained"
								color="primary"
							>
								ثبت
							</Button>
						</form>
					)}
				/>
			)}
		</>
	);
};
